import React from 'react';

import { Modal } from 'antd';
import PropTypes from 'prop-types';
import UpdateSite from '../../../UpdateSite';

const AddSiteModal = ({ showModal, setShowModal, onActionComplete }) => (
    <Modal
        title="Add site"
        okText="Add Site"
        footer={null}
        onCancel={() => setShowModal(false)}
        open={showModal}>
        <UpdateSite onActionComplete={(val) => { setShowModal(false); onActionComplete(val); }} />
    </Modal>
);

AddSiteModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    // 20241013 YUANKUI TRY TO FIX TH-37
    //          Expose onActionComplete to display latest created site
    onActionComplete: PropTypes.func.isRequired,
};

export default AddSiteModal;
